import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {downloadFileExport} from '../../api/repositories/FileExportRepository';

export async function handleFileExportDownload(
    to: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const exportId = to.params.exportId;

    if (typeof exportId !== 'string') {
        return {name: 'Home'};
    }

    // Errors already surface a toast via the API layer (expired or foreign export id).
    await downloadFileExport(exportId).catch(() => {});

    return {name: 'Home'};
}
